import { Observable, throwError } from 'rxjs';
import { Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpErrorResponse,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { retry, catchError, map } from 'rxjs/operators';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class ErrorService implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private ngZone: NgZone,
    private _notification: NotificationService,
    private _transloco: TranslocoService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          errorMessage = `Error: ${error.error.message}`;
        } else {
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        this.handleError(error);
        return throwError(errorMessage);
      })
    );
  }

  handleError(error?: any) {
    if (error instanceof HttpErrorResponse) {
      this.error(error);
    } else {
      console.error('An error occured:', error);
    }
  }

  public error(error: HttpErrorResponse): void {
    const router = this.injector.get(Router);
    switch (error.status) {
      case 0:
      case 503:
        if (router.url.indexOf('/maintenance') < 0) {
          const returnUrl = router.routerState.snapshot.url;

          this.ngZone.runGuarded(() => {
            router.navigate(['/maintenance'], {
              queryParams: { returnUrl: returnUrl ? returnUrl : '/auth/login' },
            });
          });
        }
        break;
      case 400:
        this.ngZone.runGuarded(() => {
          if (error.error && error.error.errors[0]) {
            this._notification.error(error.error.errors[0].message);
          } else if (error.error.message) {
            this._notification.error(error.error.message);
          } else {
            this._notification.error('Error 400');
          }
        });
        break;
      case 401:
        this.ngZone.runGuarded(() => {
          if (router.url.includes('/auth/login')) {
            this._notification.error(
              this._transloco.translate('login.badCredentials')
            );
          } else {
            router.navigate(['/auth/login'], {
              queryParams: { returnUrl: router.routerState.snapshot.url },
            });
            this._notification.error(
              this._transloco.translate('login.session-expired')
            );
          }
        });
        break;
      case 403:
        this.ngZone.runGuarded(() => {
          this._notification.error(error.error.errors[0].message);
        });
        router.navigate(['/auth/login'], {
          queryParams: { returnUrl: router.routerState.snapshot.url },
        });
        break;
      case 404:
        this.ngZone.runGuarded(() => {
          if (error.error && error.error.errors[0]) {
            this._notification.error(error.error.errors[0].message);
          } else if (error.error.message) {
            this._notification.error(error.error.message);
          } else {
            this._notification.error('Error 404');
          }
        });
        break;
      case 406:
        break;
      case 409:
        this.ngZone.runGuarded(() => {
          this._notification.error(error.error.message);
        });
        break;
      case 500:
        this.ngZone.runGuarded(() => {
          this._notification.error(this._transloco.translate('login.error500'));
        });
        break;
      default:
        this.ngZone.runGuarded(() => {
          this._notification.error(error.error.message);
        });
    }
  }
}
